/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateUserEvaluationSurveyAnswerDto } from './create-user-evaluation-survey-answer-dto';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateUserEvaluationSurveyDto
 */
export interface CreateUserEvaluationSurveyDto {

    /**
     * @type {JoinEntityDto}
     * @memberof CreateUserEvaluationSurveyDto
     */
    survey: JoinEntityDto;

    /**
     * @type {Array<CreateUserEvaluationSurveyAnswerDto>}
     * @memberof CreateUserEvaluationSurveyDto
     */
    answers: Array<CreateUserEvaluationSurveyAnswerDto>;
}
